import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import AudioToTextInput from './AudioToTextInput';
import { parseRequired } from '../../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-audio-to-text-input',
	callback: ({ container, context, props }: any) => {
		const name = container.getAttribute('name');
		const netteRules = container.getAttribute('data-nette-rules');
		const required = parseRequired(container.getAttribute('required'));
		const timeLimitInSeconds = parseInt(
			container.getAttribute('timeLimitInSeconds'),
		);

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AudioToTextInput
						name={name}
						netteRules={netteRules}
						isRequired={required}
						timeLimitInSeconds={timeLimitInSeconds}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
